<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <div class="page-breadcrumb"><!-- new -->
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Material</a></li>
          <li><a>Units of Measure</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
      <div class="block">
        <div class="page-header"> <!--changed new-->
          <span class="page-header__title">Units of Measure</span>
          <img src="assets/images/New_Icons/refresh-icon.svg" alt="Refresh" title="Refresh" class="page-header__icon" width="17" height="17" (click)="ngOnInit()"/>
        </div>
        <div class="list_block">
          <div class="toolbar"> <!--search and new changed new-->
            <div class="toolbar__search">
              <img src="../../../../../../assets/images/New_Icons/search-icon.svg">
              <input type="text" (ngModelChange)="onSearchChanged()" [(ngModel)]="search" name="search"
                     autocomplete="off" placeholder="Search by transaction type name"/>
            </div>
            <div class="toolbar__spacer"></div>
            <div class="toolbar__add-button" (click)="openForm()">
              <button type="button">
                <span class="toolbar__add-icon">
                  <img src="../../../../../../assets/images/New_Icons/plus-icon.svg" alt="Add Icon"/>
                </span>
                <span class="toolbar__add-text">Add New</span>
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="enableDisablePageLoader">
          <div class="adjust">
            <div class="loader2"></div>
          </div>
        </div>
        <!--uom cards-->
        <div class="cards_container" *ngIf="!enableDisablePageLoader">
          <div class="card_wrapper" *ngFor="let uom of uomsList; let i = index">
            <div class="master-card">
              <div class="master-card-header">
                <div class="master-card-title">
                  <img src="../../../../../../assets/images/New_Icons/card-heading.svg">
                  <span>{{ uom && uom.name }}</span>
                </div>
              </div>
              <div class="master-card-body">
                <div class="master-card-body-info">
                  <img src="../../../../../../assets/images/New_Icons/calendar-icon.svg">
                  <span>Updated At: {{uom && uom.updatedAt | date: "dd MMM yyyy"}}</span>
                </div>
                <div class="master-card-body-info">
                  <img src="../../../../../../assets/images/New_Icons/descriptio-card-icon.svg">
                  <span
                    class="description">{{uom && uom.description ? uom && uom.description : 'NA'}}</span>
                </div>
              </div>
              <div class="master-card-footer">
                <div class="master-card-footer-info">
                </div>
                <div class="action-icons">
                  <a>
                    <img src="../../../../../../assets/images/New_Icons/edit.svg" title="Edit Transaction Type" (click)="getUomById(uom.id)">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--uom cards end-->
        <div *ngIf="listLoader" class="loader-div">
          <div class="adjust">
            <div class="loader2 list-loader"></div>
          </div>
        </div>
        <div *ngIf="noList && !enableDisablePageLoader" class="noDataFoundMessage">Uoms Not Found</div>
      </div>
      <!--add/update form-->
      <div class="dynamic-form-wrapper" [ngClass]="{ 'floating-panel': formFieldCount <= 7, 'slide-in-overlay': formFieldCount > 7}" *ngIf="showForm">
        <!--<div *ngIf="formFieldCount > 7" class="overlay-background" (click)="closeForm()"></div>-->
        <!--outside close-->
        <div class="popup-wrapper">
          <button type="button" class="popup-close-beside" (click)="clear()" title="Close">&times;</button>
          <!-- Actual Popup -->
          <div [ngClass]="{ 'form-container-panel': formFieldCount > 7, 'popup-inner': formFieldCount <= 7}">
            <form [formGroup]="registerForm" novalidate>
              <div class="form-header">
                <div class="form-title">UOM</div>
                <button class="add-update-submit-button" (click)="addUpdateUom()" [disabled]="submitButtonDisabled">
                  <span class="icon"><img src="../../../../../../assets/images/New_Icons/tick-icon.svg"></span>
                  <span class="text">{{ submitButton ? 'Submit' : 'Update' }}</span>
                </button>
              </div>
              <div class="form-container">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Name</mat-label>
                  <input matInput id="activityName" type="text" formControlName="name" autocomplete="off" placeholder="Enter uom"/>
                  <!-- Hint -->
                  <mat-hint><i>3–20 alphabetic characters</i></mat-hint>
                  <!-- Single dynamic error -->
                  <mat-error *ngIf="(uomFormValidation.name.dirty || uomFormValidation.name.touched || submitted) && uomFormValidation.name.errors">
                    <i> {{uomFormValidation.name.hasError('required') ? 'UOM is required.': uomFormValidation.name.hasError('minlength')? 'Minimum 3 characters required.': uomFormValidation.name.hasError('maxlength')
                      ? 'Maximum 20 characters allowed.' : uomFormValidation.name.hasError('pattern') ? 'Some special characters and numbers not allowed': ''}}</i>
                  </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Description</mat-label>
                  <textarea matInput id="activityDescription" rows="3" formControlName="description" autocomplete="off" placeholder="Description"></textarea>
                  <mat-hint><i>Up to 200 characters</i></mat-hint>
                  <mat-error *ngIf="(uomFormValidation.description.dirty || uomFormValidation.description.touched || submitted) && uomFormValidation.description.hasError('maxlength')">
                    <i>Maximum 200 characters allowed.</i>
                  </mat-error>
                </mat-form-field>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!--add/update form end-->
    </div>
  </div>
</div>
